import { render } from "./FitMain.vue?vue&type=template&id=16d4425b&scoped=true"
import script from "./FitMain.vue?vue&type=script&lang=js"
export * from "./FitMain.vue?vue&type=script&lang=js"

import "./FitMain.vue?vue&type=style&index=0&id=16d4425b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d4425b"]])

export default __exports__